
























import Vue, {PropType} from 'vue';
import invert from 'invert-color';
import {v4 as uuid} from 'uuid';
import DataOutput from './DataOutput.vue';

export default Vue.extend({
    name: 'data-color',

    components: { DataOutput },

    data() {
        return {
            id: uuid(),
        };
    },

    props: {
        palette:      { type: Array as PropType<string[]>, required: true },
        value:        { type: Number, required: true },
        showHexColor: { type: Boolean, default: (): boolean => false },
    },

    computed: {
        color(): string    { return this.palette[this.value]; },
        inverted(): string { return invert(this.palette[this.value], true); },
    },
});
